import "core-js/modules/es.array.index-of.js";
// Sorts an array of objects based on a given list of orders, based on https://gist.github.com/ecarter/1423674
export function sortByOrderList(key, orderList) {
  return function (a, b) {
    var lhs = a[key],
      rhs = b[key];
    return orderList.indexOf(lhs) - orderList.indexOf(rhs);
  };
}